export default __webpack_public_path__ + "static/media/myintegra-logo.2362a1c2.png";